<template>
    <div id="main-box" style="overflow:auto;">
        <!--    batchSetPrice 稍后优化-->
        <div id="content-box">
            <div>
                <el-form label-width="100px">
                    <el-row>
                        <el-col :span="6">
                            <el-form-item label="商品spuid:">
                                <el-input v-model="queryForm.productIds" placeholder="请输入内容"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">

                            <el-form-item label="规格编码:">
                                <el-input clearable v-model="queryForm.speCode" placeholder="请输入内容"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="商品Skuid:">
                                <el-input v-model="queryForm.productSkuIds" placeholder="请输入内容"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="商品品牌">
                                <el-select filterable remote v-model="queryForm.brandIds"
                                           placeholder="请选择商品品牌（可搜索）" clearable style="width:100%;"
                                           :remote-method="remoteMethod2" @blur="select_blur_brand">
                                    <el-option v-for="(item, index) in brandList" :key="index" :label="item.name"
                                               :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="6">
                            <el-form-item label="商品类型:">
                                <el-cascader v-model="queryForm.categoryIds" :options="categoryTreeList" filterable
                                             clearable
                                             change-on-select style="width:100%;"></el-cascader>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="商品状态">
                                <el-select v-model="queryForm.isShelves" style="width:100%;">
                                    <el-option :value="null" label="全部"></el-option>
                                    <el-option :value="true" label="上架"></el-option>
                                    <el-option :value="false" label="下架"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="同步状态">
                                <el-select v-model="queryForm.isPush" style="width:100%;">
                                    <el-option :value="null" label="全部"></el-option>
                                    <el-option :value="true" label="已同步"></el-option>
                                    <el-option :value="false" label="未同步"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="远程Id">
                                <el-input v-model="queryForm.remoteId" placeholder="请输入远程Id"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="商品名称">
                                <el-input clearable v-model="queryForm.ProductName"
                                          placeholder="请输入远程Id"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="商品型号">
                                <el-input clearable v-model="queryForm.ProductModel"
                                          placeholder="请输入远程Id"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-form-item>
                        <div class="flex">
                            <el-button type="primary" @click="search">筛选</el-button>
                            <el-button @click="empty">重置</el-button>
                            <toolbar class="mgl10" :buttonList="buttonList_toolBar"
                                     @callFunction="callFunction"></toolbar>
                        </div>
                    </el-form-item>
                </el-form>
            </div>

            <el-table id="table-box" :data="tableList" highlight-current-row v-loading="tableLoading"
                      :element-loading-text="loadingText" element-loading-spinner="el-icon-loading"
                      element-loading-background="rgba(0, 0, 0, 0.8)" @selection-change="handleSelectionChange"
                      style="width: 100%"
                      border>
                <el-table-column type="selection" min-width="60" align="center">
                </el-table-column>
                <el-table-column prop="id" label="编号" min-width="180" align="center"></el-table-column>
                <el-table-column prop="remoteId" label="远程Id" min-width="180" align="center"></el-table-column>
                <el-table-column label="远程审核状态" min-width="180" align="center">
                    <template slot-scope="scoped">
                        <el-tag v-if="scoped.row.remoteShelvesAuditStatus == 2" type="success">审核通过</el-tag>
                        <el-tag v-if="scoped.row.remoteShelvesAuditStatus == 0" type="info">待提交</el-tag>
                        <el-tag v-if="scoped.row.remoteShelvesAuditStatus == 1" type="danger">待审核</el-tag>
                        <el-tag v-if="scoped.row.remoteShelvesAuditStatus == 3" type="warning">审核不通过</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="productId" label="Spuid" min-width="100" align="center"></el-table-column>
                <el-table-column label="设置默认库存" min-width="120" align="center">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.defaultStock"></el-input>
                        <el-button style="margin-top:15px;" size="mini" type="success" @click="setStock(scope.row)">修改库存
                        </el-button>
                    </template>
                </el-table-column>
                <el-table-column label="是否启用仓库库存" min-width="150" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.isUseWarehouseInventory" type="success" effect="dark">已启用</el-tag>
                        <el-tag v-else type="info" effect="dark">未启用</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="marketPrice" label="设置区域" min-width="180" align="center">
                    <template slot-scope="scope">
                        <el-button type="primary" size="small" @click="setZone(scope.row)">设置区域</el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="speCode" label="规格编码" min-width="180" align="center"></el-table-column>
                <el-table-column prop="productSkuId" label="Skuid" min-width="180" align="center"></el-table-column>
                <el-table-column prop="productSkuId" label="平台名称" min-width="180" align="center">
                    <template slot-scope="scope">
                        <el-tag effect="plain" size="small" v-if="scope.row.platformType === 1"> 京东开普勒</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="platformCode" label="平台商品编码" min-width="180"
                                 align="center"></el-table-column>
                <el-table-column label="商品规格" align="center" width="120">
                    <template slot-scope="scope">
            <span style="display: inline-block;margin-right:10px;">{{
                scope.row.propertyJsonExt ? scope.row.propertyJsonExt :
                    scope.row.propertyJson
                }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="商品状态" width="80" align="center" fixed="right">
                    <template slot-scope="scope">
            <span :style="{ color: scope.row.isShelves ? '#67C23A' : 'red' }">{{
                scope.row.isShelves ? '上架' : '下架'
                }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="同步状态" width="80" align="center" fixed="right">
                    <template slot-scope="scope">
            <span :style="{ color: scope.row.isPush ? '#67C23A' : 'red' }">{{
                scope.row.isPush ? '已同步' : '未同步'
                }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="价格状态" width="120" align="center" fixed="right">
                    <template slot-scope="scope">
                        <div>

                            <!--              isPricePush  true    false-->
                            <div v-if="isAsyncPrice">
                                <el-button v-if="scope.row.isPricePush" type="info" size="small">已同步
                                </el-button>
                                <el-button v-else type="primary" size="small" @click="asyncPrice(scope.row)">未同步
                                </el-button>
                            </div>

                            <el-button style="margin-top: 10px" v-if="isEditPrice" type="primary" size="small"
                                       @click="editPrice(scope.row)">修改价格
                            </el-button>
                        </div>


                        <!--              <el-button type="primary" size="small" @click="asyncPrice(scope.row)">同步价格</el-button>-->

                        <!--                            <el-tag-->
                        <!--                                v-if="scope.row.isPush"-->
                        <!--                                type="success"-->
                        <!--                                effect="dark">-->
                        <!--                              已同步-->
                        <!--                            </el-tag>-->
                        <!--                            <el-tag-->
                        <!--                                v-if="scope.row.isPush"-->
                        <!--                                type="success"-->
                        <!--                                effect="dark">-->
                        <!--                              已同步-->
                        <!--                            </el-tag>-->
                        <!--                            <span :style="{ color: scope.row.isPush ? '#67C23A' : 'red' }">{{-->
                        <!--                                scope.row.isPush ? '已同步' : '未同步'-->
                        <!--                              }}</span>-->
                    </template>
                </el-table-column>
                <el-table-column v-if="this.priceType == 0" prop="costPrice" label="成本价" min-width="180" align="center"></el-table-column>
                <el-table-column prop="supplyPrice" label="供货价" min-width="180" align="center">
                    <template slot-scope="scope">
                        <el-input @change="singleModel()" v-model="scope.row.supplyPrice"
                                  placeholder="请输入内容"></el-input>
                    </template>
                </el-table-column>
                <el-table-column v-if="this.priceType == 0" prop="merchantsPrice" label="商家价" min-width="180" align="center">
                    <template slot-scope="scope">
                        <el-input v-if="scope.row.priceType == 0" v-model="scope.row.merchantsPrice"
                                  placeholder="请输入内容"></el-input>
                        <el-input v-if="scope.row.priceType == 1" disabled v-model="scope.row.supplyPrice"
                                  placeholder="请输入内容"></el-input>
                    </template>
                </el-table-column>
                <el-table-column v-if="this.priceType == 0" prop="retailPrice" label="零售价" min-width="180" align="center">
                    <template slot-scope="scope">
                        <el-input v-if="scope.row.priceType == 0" v-model="scope.row.retailPrice"
                                  placeholder="请输入内容"></el-input>
                        <el-input v-if="scope.row.priceType == 1" disabled v-model="scope.row.supplyPrice"
                                  placeholder="请输入内容"></el-input>
                    </template>
                </el-table-column>
                <!--          <el-table-column-->
                <!--            prop="merchantsPrice"-->
                <!--            label="商家价"-->
                <!--            min-width="180"-->
                <!--            align="center"-->
                <!--          >-->
                <!--            <template slot-scope="scope">-->
                <!--              <el-input v-model="scope.row.merchantsPrice" placeholder="请输入内容"></el-input>-->
                <!--            </template>-->
                <!--          </el-table-column>-->
                <el-table-column prop="marketPrice" v-if="this.priceType == 0" label="市场价" min-width="180" align="center">
                    <template slot-scope="scope">
                        <el-input v-if="scope.row.priceType == 0" v-model="scope.row.marketPrice"
                                  placeholder="请输入内容"></el-input>
                        <el-input v-if="scope.row.priceType == 1" disabled v-model="scope.row.supplyPrice"
                                  placeholder="请输入内容"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="marketPrice" label="备注" min-width="180" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.remoteNote }}
                    </template>
                </el-table-column>
                <!--          <el-table-column-->
                <!--              prop="defaultStock"-->
                <!--              label="销售库存"-->
                <!--              min-width="180"-->
                <!--              align="center"-->
                <!--          >-->
                <!--            <template slot-scope="scope">-->
                <!--              <el-input v-model="scope.row.defaultStock" placeholder="请输入市场价"></el-input>-->
                <!--            </template>-->
                <!--          </el-table-column>-->
                <el-table-column label="商品图片" min-width="180" align="center">
                    <template slot-scope="scope">
                        <img :src="scope.row.imageUrl" width="120" alt="暂无"/>
                    </template>
                </el-table-column>
                <el-table-column prop="productName" label="商品名称" min-width="180" align="center"></el-table-column>
                <el-table-column prop="brandName" label="商品品牌" min-width="180" align="center"></el-table-column>
                <el-table-column prop="categoryName" label="商品类型" min-width="180" align="center"></el-table-column>
                <el-table-column prop="creationTime" label="操作时间" min-width="180" align="center"></el-table-column>
                <el-table-column label="操作" align="center" min-width="250" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="primary" size="small" @click="updateSupPrice([scope.row])" v-if="isCopySupplyPrice">复制供货价</el-button>
                        <el-button type="primary" size="small" @click="switchShelves(scope.row)">
                            {{ scope.row.isShelves ? '下架' : '上架' }}
                        </el-button>
                        <el-button v-if="isProductSync" type="primary" size="small" @click="syncProduct1(scope.row)">
                            商品同步
                        </el-button>
                        <el-button v-if="isDetail" type="primary" size="small" @click="detail(scope.row)">详情
                        </el-button>
                        <!--              <toolbar :buttonList="buttonList_table" :funcParams="scope.row" @callFunction="callFunction"></toolbar>-->
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination class="pagination" layout="total, sizes, prev, pager, next, jumper" :total="total"
                           :current-page="queryForm.pageIndex" :pageSize="queryForm.pageSize"
                           @current-change="handleCurrentChange"
                           @size-change="handleSizeChange"></el-pagination>

        </div>

        <el-dialog title="批量" :visible.sync="addProductDialog" v-if="addProductDialog" v-model="addProductDialog"
                   :close-on-click-modal="false" width="90%">
            <el-form ref="addProductForm" :model="addProductForm" label-width="100px">
                <!-- <div style="background-color: #F3F3F3;padding: 20px 20px 0 20px;border-radius: 6px;margin-bottom: 20px;"> -->
                <!--            <div>-->
                <!--              <el-form-item label="是否过滤已授权的商品">-->
                <!--                <el-radio-group v-model="addProductForm.SaleableFiltered">-->
                <!--                  <el-radio :label="true">是</el-radio>-->
                <!--                  <el-radio :label="false">否</el-radio>-->
                <!--                </el-radio-group>-->
                <!--              </el-form-item>-->
                <!--            </div>-->
                <el-row>
                    <el-col :span="6">
                        <el-form-item label="商品id:">
                            <el-input v-model="addProductForm.ProductIds" placeholder="请输入商品Id"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="供应商名称:">
                            <el-input v-model="addProductForm.supplierName" placeholder="请输入供应商名称"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="商品名称:">
                            <el-input v-model="addProductForm.ProductName" placeholder="请输入商品名称"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="商品型号:">
                            <el-input v-model="addProductForm.ProductModel" placeholder="请输入型号"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="6">
                        <el-form-item label="商品类型">
                            <el-cascader v-model="addProductForm.CategoryIds" :options="categoryTreeList" filterable
                                         clearable
                                         change-on-select></el-cascader>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="商品品牌">
                            <el-select filterable remote v-model="addProductForm.BrandIds"
                                       placeholder="请选择商品品牌（可搜索）" clearable
                                       :remote-method="remoteMethod2" @blur="select_blur_brand">
                                <el-option v-for="(item, index) in brandList" :key="index" :label="item.name"
                                           :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item>
                            <el-button type="primary" @click="search2">查询</el-button>
                            <el-button type="danger" @click="empty2">重置</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>
                <!-- </div> -->
            </el-form>
            <el-table :data="productList" @selection-change="handleSelectionChange2" border v-loading="tableLoading2"
                      element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
                      element-loading-background="rgba(0, 0, 0, 0.8)">
                <el-table-column type="selection" width="50" fixed align="center"></el-table-column>
                <el-table-column prop="productSkuId" label="skuId" min-width="80" align="center"></el-table-column>
                <el-table-column prop="productId" label="productId" min-width="100" align="center"></el-table-column>
                <el-table-column prop="productName" label="商品名称" align="center" min-width="350"></el-table-column>
                <el-table-column prop="productName" label="商品名称" align="center" min-width="350"></el-table-column>
                <el-table-column prop="supplierName" label="供应商名称" align="center"
                                 min-width="350"></el-table-column>
                <el-table-column prop="productSkuId" label="平台名称" min-width="180" align="center">
                    <template slot-scope="scope">
                        <el-tag effect="plain" size="small" v-if="scope.row.platformType === 1"> 京东开普勒</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="platformCode" label="平台商品编码" min-width="180"
                                 align="center"></el-table-column>
                <el-table-column prop="categoryName" label="商品类型" min-width="110" align="center"></el-table-column>
                <el-table-column prop="brandName" label="商品品牌" min-width="110" align="center"></el-table-column>
                <el-table-column prop="productModel" label="商品型号" min-width="110" align="center"></el-table-column>
                <!--          <el-table-column-->
                <!--              prop="productName"-->
                <!--              min-width="130"-->
                <!--              align="center"-->
                <!--              label="商品名称">-->
                <!--          </el-table-column>-->
                <!--          <el-table-column-->
                <!--              prop="distributorName"-->
                <!--              min-width="130"-->
                <!--              align="center"-->
                <!--              label="分销商">-->
                <!--          </el-table-column>-->
                <el-table-column prop="productSpec" min-width="130" align="center" label="规格名称">
                    <template slot-scope="scope">
                        {{ scope.row.productSpecExt ? scope.row.productSpecExt : scope.row.productSpec }}
                    </template>
                </el-table-column>
                <el-table-column prop="costPrice" min-width="110" align="center" label="成本价">
                </el-table-column>
                <el-table-column label="供货价" min-width="220" align="center">
                    <template slot="header" slot-scope="scope">
                        <p>供货价</p>
                        <el-input-number v-model="count1" :precision="2" :min="0.01" :step="0.01" :max="0.99"
                                         size="mini">
                        </el-input-number>
                        <el-button size="mini" class="table-header-btn" @click="handleSync('count1', 'supplyPrice')">同步
                        </el-button>
                    </template>
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.supplyPrice" placeholder="请输入供货价"></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="商家价" min-width="220" align="center" v-if="this.priceType == 0">
                    <template slot="header" slot-scope="scope">
                            <p>商家价</p>
                            <el-input-number v-model="count2" :precision="2" :min="0.01" :step="0.01" :max="0.99"
                                             size="mini">
                            </el-input-number>
                            <el-button size="mini" class="table-header-btn"
                                       @click="handleSync('count2', 'merchantsPrice')">
                                同步
                            </el-button>
                    </template>
                    <template slot-scope="scope">
                        <el-input v-if="scope.row.priceType == 0" v-model="scope.row.merchantsPrice"
                                  placeholder="请输入商家价"></el-input>
                        <el-input disabled v-if="scope.row.priceType == 1" v-model="scope.row.supplyPrice"></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="零售价" min-width="220" align="center" v-if="this.priceType == 0">
                    <template slot="header" slot-scope="scope">
                            <p>零售价</p>
                            <el-input-number v-model="count3" :precision="2" :min="0.01" :step="0.01" :max="0.99"
                                             size="mini">
                            </el-input-number>
                            <el-button size="mini" class="table-header-btn"
                                       @click="handleSync('count3', 'retailPrice')">同步
                            </el-button>
                    </template>
                    <template slot-scope="scope">
                        <el-input v-if="scope.row.priceType == 0" v-model="scope.row.retailPrice"
                                  placeholder="请输入零售价"></el-input>
                        <el-input disabled v-if="scope.row.priceType == 1" v-model="scope.row.supplyPrice"></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="市场价" min-width="220" align="center" v-if="this.priceType == 0">

                    <template slot="header" slot-scope="scope">
                            <p>市场价</p>
                            <el-input-number v-model="count4" :precision="2" :min="0.01" :step="0.01" :max="0.99"
                                             size="mini">
                            </el-input-number>
                            <el-button size="mini" class="table-header-btn"
                                       @click="handleSync('count4', 'marketPrice')">同步
                            </el-button>
                    </template>
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.marketPrice" v-if="scope.row.priceType == 0"
                                  placeholder="请输入市场价"></el-input>
                        <el-input disabled v-model="scope.row.supplyPrice" v-if="scope.row.priceType == 1"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="defaultStock" label="设置默认库存" min-width="220" align="center">
                    <template slot="header" slot-scope="scope">
                        <p>设置默认库存</p>
                        <el-input-number v-model="count5" :precision="0" :min="0" :step="1" size="mini">
                        </el-input-number>
                        <el-button size="mini" class="table-header-btn" @click="syncStock">同步
                        </el-button>
                    </template>
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.defaultStock" placeholder="请输入默认库存"></el-input>
                    </template>
                </el-table-column>
                <!--        <el-table-column-->
                <!--            prop="marketPrice"-->
                <!--            label="设置区域"-->
                <!--            min-width="180"-->
                <!--            align="center"-->
                <!--        >-->
                <!--          <template slot-scope="scope">-->
                <!--            <el-button type="primary" size="small">设置区域</el-button>-->
                <!--          </template>-->
                <!--        </el-table-column>-->
                <el-table-column min-width="160" align="center" label="操作">
                    <template slot="header" slot-scope="scope">
                        <p>操作</p>
                        <el-button size="mini" @click="upordown(true)">上架
                        </el-button>
                        <el-button size="mini" class="table-header-btn" @click="upordown(false)">下架
                        </el-button>
                    </template>
                    <template slot-scope="scope">
                        <el-radio-group v-model="scope.row.isShelves">
                            <el-radio :label="true">上架</el-radio>
                            <el-radio :label="false">下架</el-radio>
                        </el-radio-group>
                    </template>
                </el-table-column>
            </el-table>
            <div class="flex flex-center flex-sb mgt10">
                <div>
                    <el-button @click.native="addProductDialog = false">取消</el-button>
                    <el-button type="primary" @click.native="submitSetPrice">确认添加</el-button>
                </div>
                <el-pagination layout="total, sizes, prev, pager, next, jumper" :total="total2"
                               :current-page="addProductForm.pageIndex" :pageSize="addProductForm.pageSize"
                               @current-change="handleCurrentChange2" @size-change="handleSizeChange2"></el-pagination>
            </div>
            <!-- <div slot="footer" class="dialog-footer" style="width:100%;">
              <el-button @click.native="addProductDialog = false">取消</el-button>
              <el-button type="primary" @click.native="submitSetPrice">确认添加</el-button>
            </div> -->
        </el-dialog>

        <el-dialog title="设置价格22222" :visible.sync="setPriceDialog" v-if="setPriceDialog" v-model="setPriceDialog"
                   :close-on-click-modal="false" width="90%">
            <el-table border :data="specList" :header-cell-style="{ background: '#F3F3F3' }" id="act-set-table">
                <el-table-column prop="productName" min-width="130" align="center" label="商品名称">
                </el-table-column>
                <el-table-column prop="distributorName" min-width="130" align="center" label="分销商">
                </el-table-column>
                <el-table-column prop="productSpec" min-width="130" align="center" label="规格名称">
                </el-table-column>
                <el-table-column prop="costPrice" min-width="110" align="center" label="成本价">
                </el-table-column>
                <el-table-column label="供货价" min-width="110" align="center" style="border: red solid 1px;">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.supplyPrice" placeholder="请输入"></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="商家价" min-width="110" align="center" style="border: red solid 1px;">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.merchantsPrice" placeholder="请输入"></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="零售价" min-width="110" align="center" style="border: red solid 1px;">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.retailPrice" placeholder="请输入"></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="市场价" min-width="110" align="center" style="border: red solid 1px;">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.marketPrice" placeholder="请输入"></el-input>
                    </template>
                </el-table-column>
                <el-table-column min-width="155" align="center" label="操作">
                    <template slot-scope="scope">
                        <el-radio-group v-model="scope.row.isShelves">
                            <el-radio :label="true">上架</el-radio>
                            <el-radio :label="false">下架</el-radio>
                        </el-radio-group>
                    </template>
                </el-table-column>
            </el-table>
            <div slot="footer" class="dialog-footer">
                <el-button @click="setPriceDialog = false">取消</el-button>
                <el-button type="primary" @click.native="submitSetPrice" :loading="submitLoading">保存</el-button>
            </div>
        </el-dialog>

        <el-dialog title="批量设置价格" :visible.sync="batchSetPriceDialog" v-if="batchSetPriceDialog"
                   v-model="batchSetPriceDialog" :close-on-click-modal="false" width="90%">
            <el-table border :data="batchSetPriceList" :header-cell-style="{ background: '#F3F3F3' }"
                      id="act-set-table">
                <el-table-column prop="productName" min-width="130" align="center" label="商品名称">
                </el-table-column>
                <el-table-column prop="distributorName" min-width="130" align="center" label="分销商">
                </el-table-column>
                <el-table-column prop="propertyJson" min-width="130" align="center" label="规格名称">
                </el-table-column>
                <el-table-column prop="costPrice" min-width="110" align="center" label="成本价">
                </el-table-column>
                <el-table-column label="供货价" min-width="110" align="center">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.supplyPrice" placeholder="请输入"></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="商家价" min-width="110" align="center">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.merchantsPrice" placeholder="请输入"></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="零售价" min-width="110" align="center">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.retailPrice" placeholder="请输入"></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="市场价" min-width="110" align="center">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.marketPrice" placeholder="请输入"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="defaultStock" label="设置默认库存" min-width="180" align="center">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.defaultStock" placeholder="请输入市场价"></el-input>
                    </template>
                </el-table-column>
                <!--        <el-table-column-->
                <!--            prop="marketPrice"-->
                <!--            label="设置区域"-->
                <!--            min-width="180"-->
                <!--            align="center"-->
                <!--        >-->
                <!--          <template slot-scope="scope">-->
                <!--            <el-button type="primary" size="small">设置区域</el-button>-->
                <!--          </template>-->
                <!--        </el-table-column>-->
                <el-table-column min-width="155" align="center" label="操作">
                    <template slot-scope="scope">
                        <el-radio-group v-model="scope.row.isShelves">
                            <el-radio :label="true">上架</el-radio>
                            <el-radio :label="false">下架</el-radio>
                        </el-radio-group>
                    </template>
                </el-table-column>
            </el-table>
            <div slot="footer" class="dialog-footer">
                <el-button @click="batchSetPriceDialog = false">取消</el-button>
                <el-button type="primary" @click.native="submitBatchSetPrice" :loading="submitLoading">保存</el-button>
            </div>
        </el-dialog>
        <el-dialog title="区域库存设置" :visible.sync="zoneVisible" width="50%">
            <div style="margin-bottom:20px;">
                <el-input v-model="configData" clearable size="small" style="width: 200px;margin-right:20px;"
                          placeholder="请输入配置信息"></el-input>
                <el-button type="primary" @click="setConfig" size="small">一键配置</el-button>
                <el-button type="primary" @click="clearConfig" size="small">清空配置</el-button>
                <el-button type="primary" @click="toggleRowExpansion" size="small">全部{{
                    isExpansion ? '收缩' : '展开'
                    }}
                </el-button>
            </div>
            <div style="height:60vh;overflow-y:auto;">
                <el-table ref="topicTable" :data="zoneData" style="width: 100%;margin-bottom: 20px;" row-key="id" border
                          default-expand-all :tree-props="{ children: 'children', hasChildren: 'hasChildren' }">
                    <el-table-column prop="areaName" label="省市">
                    </el-table-column>
                    <el-table-column label="库存">
                        <template slot-scope="scope">
                            <input type="number" v-model="scope.row.stock"
                                   style="height:35px;padding:0 5px;border:1px solid #eee;border-radius:5px;">
                            <!-- <el-input type="number" ></el-input> -->
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <span slot="footer" class="dialog-footer">
        <el-button @click="zoneVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleUpdateSaleArea">确 定</el-button>
      </span>
        </el-dialog>
    </div>
</template>
<script>
import {
    SaleableSkuGetAll,
    GetProductList,
    GetAllReseller,
    brandGetAll,
    CategoryGetTree,
    GetProductSkuByProductId,
    SaleableSkuBatchCreate,
    SaleableSkuUpdate,
    ProductSync,
    SaleableSkuBatchUpdate,
    GetSaleableAreas, // 获取区域 已配置
    AreaGetAll, // 获取所有的区域
    GetAreaTree,
    UpdateSaleableAreas,
    UpdateDefaultStock,
    GetProductSkuForSaleable,
    BatchUpdateUseWarehouseInventory, OrderAfterSaleConfirm, PushPrice, DeleteUser, BatchUpdatePrice
} from "../../api/api";
import toolbar from "../../components/Toolbar";
import {getButtonList} from "../../promissionRouter";

export default {
    components: {toolbar},
    data() {
        return {
            buttonList_toolBar: [],
            buttonList_table: [],
            tableLoading: false,
            tableLoading2: false,
            submitLoading: false,

            queryForm: {
                ProductName: '',
                ProductModel: '',
                speCode: null,
                productIds: null,
                productSkuIds: null,
                brandIds: null,
                categoryIds: null,
                isShelves: null,
                isPush: null,
                remoteId: '',
                pageIndex: 1,
                pageSize: 10
            },
            total: 0,
            tableList: [],
            currentRow: [],

            addProductDialog: false,
            brandList: [],
            categoryTreeList: [],
            addProductForm: {
                ProductIds: null,
                ProductName: null,
                ProductModel: null,
                CategoryIds: null,
                BrandIds: null,
                supplierName: '',
                pageIndex: 1,
                pageSize: 10,
                // SaleableFiltered: true,
            },
            total2: 0,
            productList: [],
            currentRow2: [],

            setPriceDialog: false,
            specList: [],

            batchSetPriceDialog: false,
            batchSetPriceList: [],
            zoneVisible: false,
            loadingText: '拼命加载中',
            zoneData: [],
            configData: null,
            saleableSkuId: 0,
            baseAreaList: [], // 后台返回的未格式化的基础区域数据
            alreadySetArae: [],
            updateRes: [],
            isExpansion: true,
            isProductSync: false,
            isDetail: false,
            isEditPrice: false,
            isAsyncPrice: false,
            count1: undefined,
            count2: undefined,
            count3: undefined,
            count4: undefined,
            count5: undefined,
            priceType: null,
            isCopySupplyPrice: false
        };
    },
    created() {
        this.distributorId = parseInt(this.$route.query.distributorId);
        this.distributorName = this.$route.query.distributorName;
        this.priceType = this.$route.query.priceType;
    },
    mounted() {
        this.getTableList();
        this.renderButton();
        this.getBrandList();
        this.getCategoryTreeList();
    },
    methods: {
        singleModel(type) {
            let a = type;
        },
        // 批量同步价格
        BatchAsyncPrice() {
            if (!this.currentRow.length) {
                return this.$message.error('请选择要同步的数据')
            }
            // console.log(3333)

            let saleableSkuIds = [];
            this.currentRow.forEach((item, index) => {
                saleableSkuIds.push(item.id)
            })
            let params = {
                resellerId: this.distributorId,
                saleableSkuIds: saleableSkuIds
            }

            this.$confirm("确认批量同步所选商品价格吗?", "提示", {
                type: "warning",
                closeOnClickModal: false,
            }).then(async () => {
                let res = await PushPrice(params);
                if (res.data.success) {
                    if (res.data.result && res.data.result.isSuccess) {
                        this.$message.success(res.data.result.message)
                        this.currentRow = []
                        await this.getTableList();
                    } else {
                        this.$message.error(res.data.result.message)
                    }
                } else {
                    this.$message.error(res.data.error.message)
                }
                // console.log('this.currentRow', this.currentRow);
            }).catch(() => {
            });
        },
        async asyncPrice(row) {
            // console.log('row', row);
            // console.log('同步')
            let saleableSkuIds = [];
            saleableSkuIds.push(row.id)
            // console.log('saleableSkuIds', saleableSkuIds)
            let params = {
                resellerId: this.distributorId,
                saleableSkuIds: saleableSkuIds
            }
            console.log('saleableSkuIds', params)
            let res = await PushPrice(params);
            if (res.data.success) {
                if (res.data.result && res.data.result.isSuccess) {
                    this.$message.success(res.data.result.message)
                    await this.getTableList();
                } else {
                    this.$message.error(res.data.result.message || '同步失败, 请重试')
                }
            } else {
                this.$message.error(res.data.error.message || '同步失败,请重试')
            }
        },
        async cancelWarehouseStock() {
            if (!this.currentRow.length) {
                return this.$message.error('请选择要处理的数据')
            }
            this.$confirm("确认禁用仓库库存吗?", "提示", {
                type: "warning",
                closeOnClickModal: false,
            }).then(async () => {
                let saleableSkuIds = [];
                let ids = this.currentRow.map((item) => {
                    saleableSkuIds.push(item.id)
                })
                let params = {isUse: false, saleableSkuIds: saleableSkuIds}
                let res = await BatchUpdateUseWarehouseInventory(params);
                // console.log('res', res);
                if (res.data.success) {
                    this.$message.success('已禁用仓库库存');
                    this.currentRow = [];
                    await this.getTableList();
                } else {
                    this.$message.error(res.data.error.message || '设置失败,请重试');
                }
            }).catch(() => {
            });
        },
        async useWarehouseStock() {
            if (!this.currentRow.length) {
                return this.$message.error('请选择要处理的数据')
            }
            this.$confirm("确认开启仓库库存吗?", "提示", {
                type: "warning",
                closeOnClickModal: false,
            }).then(async () => {
                let saleableSkuIds = [];
                let ids = this.currentRow.map((item) => {
                    saleableSkuIds.push(item.id)
                })
                let params = {isUse: true, saleableSkuIds: saleableSkuIds}
                let res = await BatchUpdateUseWarehouseInventory(params);
                // console.log('res', res);
                if (res.data.success) {
                    this.$message.success('开启库存成功');
                    this.currentRow = [];
                    await this.getTableList();
                } else {
                    this.$message.error(res.data.error.message || '设置失败,请重试');
                }
            }).catch(() => {
            });
        },
        setData() {
            let tempData = this.zoneData;
            // console.log('this.zoneData', this.zoneData)
            tempData.forEach(item => {
                item.stock = this.configData ? this.configData : null;
                if (item.children) {
                    item.children.forEach(item => {
                        item.stock = this.configData ? this.configData : null;
                    })
                }
            })
            this.zoneData = tempData;
        },
        clearConfig() {
            this.configData = null;
            this.setData();
        },
        setConfig() {
            if (!this.configData) {
                return this.$message.error('请输入配置信息')
            }
            this.setData()
        },
        toggleRowExpansion() {
            this.isExpansion = !this.isExpansion
            this.toggleRowExpansion_forAll(this.zoneData, this.isExpansion);
        },
        toggleRowExpansion_forAll(data, isExpansion) {
            data.forEach(item => {
                this.$refs.topicTable.toggleRowExpansion(item, isExpansion);
                if (item.children != undefined && item.children != null) {
                    this.toggleRowExpansion_forAll(item.children, isExpansion);
                }
            })
        },
        async setStock(row) {
            let params = {
                id: row.id,
                defaultStock: Number(row.defaultStock)
            }
            await UpdateDefaultStock(params).then((res) => {
                if (res.data.success) {
                    this.$message.success('修改库存成功');
                    this.getTableList();
                } else {
                    this.$message.error(res.data.msg);
                }
            });

        },
        async editPrice(data) {
            // 根据类型处理价格
            if (data.priceType == 1) {
                data.merchantsPrice = data.supplyPrice;
                data.retailPrice = data.supplyPrice;
                data.marketPrice = data.supplyPrice;
            }
            // let row = data.funcParams;
            let row = data;
            if (
                Number(row.marketPrice) < Number(row.retailPrice)
            ) {
                return this.$message.error('市场价必须大于等于C端价！');
            }
            if (
                Number(row.retailPrice) < Number(row.merchantsPrice)
            ) {
                return this.$message.error('C端价必须大于等于B端价');
            }
            if (
                Number(row.merchantsPrice) < Number(row.supplyPrice)
            ) {
                return this.$message.error('B端价必须大于等于供货价');
            }
            // console.log('data', data)
            // return;

            // let saleableSkuIds = [];
            // saleableSkuIds.push(row.productSkuId)
            // let params = {
            //   resellerId: this.distributorId,
            //   saleableSkuIds: saleableSkuIds
            // };


            let params = {};
            params.supplyPrice = row.supplyPrice;
            params.retailPrice = row.retailPrice;
            params.merchantsPrice = row.merchantsPrice;
            params.marketPrice = row.marketPrice;
            // params.isActive = row.isPush;
            // params.isShelves = row.isShelves;
            params.id = row.id;
            // params.productSkuId = row.productSkuId;
            // params.defaultStock = Number(row.defaultStock);
            let items = [];
            items[0] = params;
            await BatchUpdatePrice({items}).then((res) => {
                console.log('===', res);
                if (res.data.success) {
                    this.$message.success('修改价格成功');
                    // if (res.data.result.success) {
                    //   this.$message.success(res.data.result.message)
                    this.getTableList();
                    // } else {
                    //   this.$message.error(res.data.result.message)
                    // }

                } else {
                    this.$message.error(res.data.msg || '操作失败,请重试');
                }
            });
        },
        handleUpdateSaleArea() {
            this.updateRes = []
            this.filterData(this.zoneData)
            setTimeout(() => {
                UpdateSaleableAreas({
                    saleableSkuId: this.saleableSkuId,
                    saleableAreaItems: this.updateRes
                }).then(res => {
                    if (res.data.success) {
                        this.updateRes = []
                        this.zoneData = []
                        this.alreadySetArae = []
                        this.zoneVisible = false
                        this.$message.success('设置成功')
                    } else {
                        this.$message.error(res.data.error.message)
                    }
                })
            }, 300)
        },
        filterData(list) {
            list.forEach(i => {
                if (i.stock >= 0 && i.stock !== null && i.stock !== '' && i.stock !== undefined) {
                    this.updateRes.push({
                        "areaId": i.areaId,
                        "areaName": i.areaName,
                        "areaFullId": i.areaFullId,
                        "stock": i.stock
                    })
                }
                if (i.children && i.children.length) {
                    this.filterData(i.children)
                }
            })
        },
        async setZone(row) {
            // console.log('row', row);
            this.saleableSkuId = row.id
            this.alreadySetArae = []
            // 基础区域数据没有则重新获取
            if (!this.baseAreaList.length) {
                let res = await GetAreaTree({MaxLevel: 2})
                // console.log('2级', res);
                this.baseAreaList = res.data.result.children
            }
            // 获取已设置区域库存的区域数据
            let setRes = await GetSaleableAreas({saleableSkuId: row.id});
            this.alreadySetArae = setRes.data.result
            // console.log('alreadySetArae', this.alreadySetArae)
            // 组装数据
            let list = JSON.parse(JSON.stringify(this.baseAreaList))
            this.zoneData = this.loopAreaTree(list)
            this.zoneVisible = true;
        },
        loopAreaTree(treeList, lastFullId) {
            const newList = treeList.filter(item => {
                let Level = item.data.Level;
                item.Level = Level;
                item.areaId = item.data.Id;
                item.areaName = item.data.Name;
                item.id = item.data.Id;
                item.label = item.data.Name;
                // 设置库存
                let t = this.alreadySetArae.find(i => i.areaId === item.data.Id)
                item.stock = t ? t.stock : null
                let nowFullId;
                if (Level == 1) nowFullId = '' + item.data.Id;
                if (Level == 2) nowFullId = [item.data.ParentId, item.data.Id].join(",");
                if (Level == 3) nowFullId = lastFullId + ',' + item.data.Id;
                item.areaFullId = nowFullId;
                delete item.data
                if (!item.children.length) {
                    delete item.children
                } else {
                    this.loopAreaTree(item.children, item.areaFullId)
                }
                // filter return true
                return true;
            })
            return newList;
        },
        getCategoryTreeList() {
            CategoryGetTree().then((res) => {
                this.categoryTreeList = this.loopTree(res.data.result.children);
            });
        },
        // 递归封装菜单树
        loopTree(treeList) {
            const newList = treeList.filter(item => {
                item.value = item.data.Id + '';
                item.label = item.data.Name;
                delete item.data
                if (!item.children.length) {
                    delete item.children
                } else {
                    this.loopTree(item.children)
                }
                return true;
            })
            return newList;
        },
        select_blur_brand() {
            this.getBrandList();
        },
        getBrandList() {
            let params = {
                SkipCount: 0,
                MaxResultCount: 20
            };
            let that = this;
            brandGetAll(params).then((res) => {
                if (res.data.success) {
                    that.brandList = res.data.result.items;
                }
            });
        },
        async getTableList() {
            this.queryForm.ResellerId = this.distributorId;
            this.queryForm.SkipCount = (this.queryForm.pageIndex - 1) * 10;
            this.queryForm.MaxResultCount = this.queryForm.pageSize;
            if (this.queryForm.categoryIds) {
                this.queryForm.categoryIds = this.queryForm.categoryIds.join(',');
            }
            let that = this;
            this.tableLoading = true;
            this.loadingText = '拼命加载中';
            await SaleableSkuGetAll(this.queryForm).then((res) => {
                that.tableLoading = false;
                that.total = res.data.result.totalCount;
                that.tableList = res.data.result.items;
                // console.log('that.tableList', that.tableList);
            });
        },
        handleSelectionChange(val) {
            this.currentRow = val;
        },
        handleCurrentChange(val) {
            this.queryForm.pageIndex = val;
            this.getTableList();
        },
        handleSizeChange(val) {
            this.queryForm.pageSize = val;
            this.getTableList();
        },
        search() {
            this.queryForm.pageIndex = 1;
            this.queryForm.pageSize = 10;
            this.getTableList();
        },
        empty() {
            this.queryForm.productIds = null;
            this.queryForm.productSkuIds = null;
            this.queryForm.brandIds = null;
            this.queryForm.categoryIds = null;
            this.queryForm.isShelves = null;
            this.queryForm.isPush = null;
            this.queryForm.pageIndex = 1;
            this.queryForm.pageSize = 10;
            this.queryForm.speCode = null;
            this.queryForm.ProductName = '';
            this.queryForm.ProductModel = '';
            this.getTableList();
        },
        export() {
        },
        batchImport() {
            if (this.currentRow.length == 0) {
                return this.$message.error('请选择一行数据！');
            }
        },
        batchSetPrice() {
            if (this.currentRow.length == 0) {
                return this.$message.error('请选择一行数据！');
            }
            this.batchSetPriceList = JSON.parse(JSON.stringify((this.currentRow)));
            this.batchSetPriceList.forEach(x => {
                x.distributorName = this.distributorName;
            });
            this.batchSetPriceDialog = true;
        },
        submitBatchSetPrice() {
            // console.log('batch', this.batchSetPriceList)
            // 校验
            let flag = true;
            try {
                this.batchSetPriceList.forEach(x => {
                    if (
                        Number(x.marketPrice) < Number(x.retailPrice)
                    ) {
                        flag = false;
                        this.$message.error('市场价必须大于等于C端价！');
                        throw Error();
                    }
                    if (
                        Number(x.retailPrice) < Number(x.merchantsPrice)
                    ) {
                        flag = false;
                        // console.log('c', x.retailPrice)
                        // console.log('b', x.merchantsPrice)
                        // console.log('-----', (x.retailPrice < x.merchantsPrice))
                        this.$message.error('C端价必须大于等于B端价');
                        throw Error();
                    }
                    if (
                        Number(x.merchantsPrice) < Number(x.supplyPrice)
                    ) {
                        flag = false;
                        this.$message.error('B端价必须大于等于供货价');
                        throw Error();
                    }

                    if (x.supplyPrice === null || x.supplyPrice === '') {
                        flag = false;
                        this.$message.error('请输入供货价');
                        throw Error();
                    }
                    if (!/^[0-9]+(.[0-9]{1,2})?$/.test(x.supplyPrice)) {
                        flag = false;
                        this.$message.error('供货价必须为数字（可保留两位小数）');
                        throw Error();
                    }
                    if (x.retailPrice === null || x.retailPrice === '') {
                        flag = false;
                        this.$message.error('请输入零售价');
                        throw Error();
                    }
                    if (!/^[0-9]+(.[0-9]{1,2})?$/.test(x.retailPrice)) {
                        flag = false;
                        this.$message.error('零售价必须为数字（可保留两位小数）');
                        throw Error();
                    }
                    if (x.merchantsPrice === null || x.merchantsPrice === '') {
                        flag = false;
                        this.$message.error('请输入商家价');
                        throw Error();
                    }
                    if (!/^[0-9]+(.[0-9]{1,2})?$/.test(x.merchantsPrice)) {
                        flag = false;
                        this.$message.error('商家价必须为数字（可保留两位小数）');
                        throw Error();
                    }
                    if (x.marketPrice === null || x.marketPrice === '') {
                        flag = false;
                        this.$message.error('请输入市场价');
                        throw Error();
                    }
                    if (!/^[0-9]+(.[0-9]{1,2})?$/.test(x.marketPrice)) {
                        flag = false;
                        this.$message.error('市场价必须为数字（可保留两位小数）');
                        throw Error();
                    }
                });
            } catch (e) {
            }
            if (flag) {
                // 调用接口
                let params = {items: []};
                this.batchSetPriceList.forEach(x => {
                    params.items.push({
                        supplyPrice: x.supplyPrice,
                        retailPrice: x.retailPrice,
                        merchantsPrice: x.merchantsPrice,
                        marketPrice: x.marketPrice,
                        isActive: true,
                        isShelves: x.isShelves,
                        id: x.id,
                        productSkuId: x.productSkuId,
                        defaultStock: x.defaultStock,
                    });
                });
                this.$confirm("本次操作是否同步相应的分销商？", "提示", {
                    closeOnClickModal: false,
                }).then(() => {
                    this.productCreateOrUpdateAndSync('update', params, true);
                }).catch(() => {
                    this.productCreateOrUpdateAndSync('update', params, false);
                });
            }
        },
        async skuBatchCreate(params) {
            this.submitLoading = true;
            console.log()
            await SaleableSkuBatchCreate(params).then((res) => {
                if (res.data.success) {
                    this.$message.success('提交成功');
                } else {
                    this.$message.error(res.data.error.message || '提交失败, 请重试');
                }
            });
        },
        async skuBatchUpdate(params) {
            this.submitLoading = true;
            await SaleableSkuBatchUpdate(params).then((res) => {
                if (res.data.success) {
                    this.$message.success('修改价格成功');
                } else {
                    this.$message.error(res.data.msg);
                }
            });
        },
        async syncProduct1(params) {
            // console.log('-------爱上大大----------', params)
            // let saleableSkuIds = [];
            // params && params.items.forEach((item, index)=>{
            //   saleableSkuIds.push(item.productSkuId)
            // })
            let data = {
                resellerId: this.distributorId,
                saleableSkuIds: []
            };
            // console.log('------------data------', data)
            data.saleableSkuIds.push(params.productSkuId);
            // params.forEach(x => {
            //   data.saleableSkuIds.push(x.productSkuId);
            // });
            // params.items.forEach(x => {
            //   data.saleableSkuIds.push(x.productSkuId);
            // });
            this.submitLoading = true;
            await ProductSync(data).then((res) => {
                this.submitLoading = false;
                if (res.data.success) {
                    this.$message.success(res.data.result.message);
                    this.getTableList();
                } else {
                    this.$message.error(res.data.result.message);
                }
            });
        },
        async syncProduct(params) {
            console.log('-------爱上大大----------', params)
            let saleableSkuIds = [];
            params && params.items.forEach((item, index) => {
                saleableSkuIds.push(item.productSkuId)
            })
            let data = {
                resellerId: this.distributorId,
                saleableSkuIds: saleableSkuIds
            };
            // console.log('------------data------', data)
            // data.saleableSkuIds.push(params.productSkuId);
            // params.forEach(x => {
            //   data.saleableSkuIds.push(x.productSkuId);
            // });
            // params.items.forEach(x => {
            //   data.saleableSkuIds.push(x.productSkuId);
            // });
            this.submitLoading = true;
            await ProductSync(data).then((res) => {
                this.submitLoading = false;
                if (res.data.success) {
                    this.$message.success(res.data.result.message);
                    this.getTableList();
                } else {
                    this.$message.error(res.data.result.message);
                }
            });
        },
        async productCreateOrUpdateAndSync(type, params, isSync) {
            this.tableLoading = true;
            if (type === 'create') {
                await this.skuBatchCreate(params);
                if (isSync) {
                    this.loadingText = '商品正在同步中，请稍等…';
                    await this.syncProduct(params);
                }
                this.setPriceDialog = false;
                this.addProductDialog = false;
            }
            if (type === 'update') {
                await this.skuBatchUpdate(params);
                if (isSync) {
                    this.loadingText = '商品正在同步中，请稍等…';
                    await this.syncProduct(params);
                }
                this.batchSetPriceDialog = false;
            }
            this.submitLoading = false;
            await this.getTableList();
        },
        resetScrollX() {
            var elements = document.querySelectorAll('#table-box .el-table__body-wrapper')[0];
            elements.scrollLeft = window.screen.width - 232;
        },
        oneKeySync() {
            if (this.currentRow.length == 0) {
                return this.$message.error('请选择一行数据！');
            }
            let params = {
                resellerId: this.distributorId,
                saleableSkuIds: []
            };
            let flag = true;
            try {
                this.currentRow.forEach(x => {
                    if (x.supplyPrice === null || x.supplyPrice === '') {
                        flag = false;
                        this.resetScrollX();
                        this.$message.error('请输入供货价');
                        throw Error();
                    }
                    if (x.retailPrice === null || x.retailPrice === '') {
                        flag = false;
                        this.resetScrollX();
                        this.$message.error('请输入零售价');
                        throw Error();
                    }
                    if (x.merchantsPrice === null || x.merchantsPrice === '') {
                        flag = false;
                        this.resetScrollX();
                        this.$message.error('请输入商家价');
                        throw Error();
                    }
                    if (x.marketPrice === null || x.marketPrice === '') {
                        flag = false;
                        this.resetScrollX();
                        this.$message.error('请输入市场价');
                        throw Error();
                    }
                    params.saleableSkuIds.push(x.productSkuId);
                });
            } catch (e) {
            }
            if (flag) {
                this.proSync(params);
            }
        },
        proSync(params) {
            // console.log(params)
            // return;
            this.tableLoading = true;
            this.loadingText = '商品正在同步中，请稍等…';
            ProductSync(params).then((res) => {
                this.loadingText = '拼命加载中';
                this.tableLoading = false;
                if (res.data.success) {
                    this.$message.success(res.data.result.message);
                    this.batchSetPriceDialog = false;
                    this.getTableList();
                } else {
                    this.$message.error(res.data.result.message);
                }
            });
        },
        addProduct(button, index, row) {
            // console.log('addPro', row)
            // console.log('add')
            this.addProductForm.Ids = null;
            this.addProductForm.Name = null;
            this.addProductForm.Model = null;
            this.addProductForm.CategoryIds = null;
            this.addProductForm.BrandIds = null;
            this.addProductForm.SaleableFiltered = true;
            this.addProductForm.pageIndex = 1;
            this.addProductForm.pageSize = 10;
            this.currentRow2 = [];
            this.getProList();
            this.addProductDialog = true;
        },
        // 商品列表搜索
        remoteMethod2(query) {
            let that = this;
            let params = {
                SkipCount: 0,
                MaxResultCount: 200
            };
            if (query !== '') {
                params.name = query;
            }
            brandGetAll(params).then((res) => {
                if (res.data.success) {
                    that.brandList = res.data.result.items;
                }
            });
        },
        getProList() {
            var params = JSON.parse(JSON.stringify(this.addProductForm));
            params.SkipCount = (this.addProductForm.pageIndex - 1) * 10;
            params.MaxResultCount = this.addProductForm.pageSize;
            if (params.CategoryIds) {
                params.CategoryIds = params.CategoryIds.join(",");
            }
            let that = this;
            this.tableLoading2 = true;
            params.ResellerId = this.distributorId;
            GetProductSkuForSaleable(params).then((res) => {
                // console.log('sku列表', res);
                this.tableLoading2 = false;

                // that.productList = res.data.result.items;
                let productList = res.data.result.items;
                that.total2 = res.data.result.totalCount;

                productList.forEach(x => {
                    // x.productSkuList.forEach(y => {
                    // productList.push({
                    // distributorName: this.distributorName,
                    // productId: x.productId,
                    // productName: x.productName,
                    // productSkuId: y.productSkuId,
                    // productSpec: y.productSpec,
                    x.supplyPrice = null,
                        x.retailPrice = null,
                        x.merchantsPrice = null,
                        x.marketPrice = null,
                        x.isShelves = null,
                        x.defaultStock = null,
                        x.priceType = this.priceType
                    // })
                    // });
                });

                that.productList = res.data.result.items;
                // console.log('that.productList', that.productList)
            });
        },
        search2() {
            this.addProductForm.pageIndex = 1;
            this.addProductForm.pageSize = 10;
            this.getProList();
        },
        // ProductIds: null,
        // ProductName: null,
        // ProductModel: null,
        // CategoryIds: null,
        // BrandIds: null,
        empty2() {
            this.addProductForm.ProductIds = null;
            this.addProductForm.ProductName = null;
            this.addProductForm.ProductModel = null;
            this.addProductForm.CategoryIds = null;
            this.addProductForm.BrandIds = null;
            this.addProductForm.supplierName = '';
            // this.addProductForm.SaleableFiltered = true;
            this.addProductForm.pageIndex = 1;
            this.addProductForm.pageSize = 10;
            this.getProList();
        },
        handleSelectionChange2(val) {
            val && val.forEach(item => {
                // item.productId = item.id;
                item.isActive = true
                // item.defaultStock = item.stock
            })
            this.currentRow2 = val;
            // console.log('this.currentRow2', this.currentRow2)

        },
        handleCurrentChange2(val) {
            this.addProductForm.pageIndex = val;
            this.getProList();
        },
        handleSizeChange2(val) {
            this.addProductForm.pageSize = val;
            this.getProList();
        },
        submitAddPro() {
            if (this.currentRow2.length == 0) {
                return this.$message.error('请选择商品！');
            }
            let productIds = [];
            this.currentRow2.forEach(x => {
                productIds.push(x.id);
            });
            let params = {ProductIds: productIds.join(",")};
            let that = this;
            this.specList = [];
            GetProductSkuByProductId(params).then((res) => {
                if (res.data.success) {
                    let list = res.data.result;
                    list.forEach(x => {
                        x.productSkuList.forEach(y => {
                            that.specList.push({
                                distributorName: this.distributorName,
                                productId: x.productId,
                                productName: x.productName,
                                productSkuId: y.productSkuId,
                                productSpec: y.productSpec,
                                costPrice: y.costPrice,
                                supplyPrice: null,
                                retailPrice: null,
                                merchantsPrice: null,
                                marketPrice: null,
                                isShelves: null
                            })
                        });
                    });
                }
            });
            this.setPriceDialog = true;
        },
        submitSetPrice() {
            // if (this.specList.length === 0) {
            //   return this.$message.error('暂无sku信息，无法保存!');
            // }
            // let flag = true;
            // try {
            //   this.specList.forEach(x => {
            //     if (
            //         x.marketPrice < x.retailPrice
            //     ) {
            //       flag = false;
            //       this.$message.error('市场价必须大于等于C端价！');
            //       throw Error();
            //     }
            //     if (
            //         x.retailPrice < x.merchantsPrice
            //     ) {
            //       flag = false;
            //       this.$message.error('C端价必须大于等于B端价');
            //       throw Error();
            //     }
            //     if (
            //         x.merchantsPrice < x.costPrice
            //     ) {
            //       flag = false;
            //       this.$message.error('B端价必须大于等于成本价');
            //       throw Error();
            //     }
            //
            //     if (x.supplyPrice === null || x.supplyPrice === '') {
            //       flag = false;
            //       this.$message.error('请输入供货价！');
            //       throw Error();
            //     }
            //     if (!/^[0-9]+(.[0-9]{1,2})?$/.test(x.supplyPrice)) {
            //       flag = false;
            //       this.$message.error('供货价必须为数字（可保留两位小数）');
            //       throw Error();
            //     }
            //     if (x.retailPrice === null || x.retailPrice === '') {
            //       flag = false;
            //       this.$message.error('请输入零售价！');
            //       throw Error();
            //     }
            //     if (!/^[0-9]+(.[0-9]{1,2})?$/.test(x.retailPrice)) {
            //       flag = false;
            //       this.$message.error('零售价必须为数字（可保留两位小数）');
            //       throw Error();
            //     }
            //     if (x.merchantsPrice === null || x.merchantsPrice === '') {
            //       flag = false;
            //       this.$message.error('请输入商家价！');
            //       throw Error();
            //     }
            //     if (!/^[0-9]+(.[0-9]{1,2})?$/.test(x.merchantsPrice)) {
            //       flag = false;
            //       this.$message.error('商家价必须为数字（可保留两位小数）');
            //       throw Error();
            //     }
            //     if (x.marketPrice === null || x.marketPrice === '') {
            //       flag = false;
            //       this.$message.error('请输入市场价！');
            //       throw Error();
            //     }
            //     if (!/^[0-9]+(.[0-9]{1,2})?$/.test(x.marketPrice)) {
            //       flag = false;
            //       this.$message.error('市场价必须为数字（可保留两位小数）');
            //       throw Error();
            //     }
            //     if (x.isShelves == null) {
            //       flag = false;
            //       this.$message.error('请选择上下架！');
            //       throw Error();
            //     }
            //   });
            // } catch (e) {
            // }
            // if (flag) {
            // let params = {
            //   resellerId: this.distributorId,
            //   items: []
            // };
            // this.specList.forEach(x => {
            //   params.items.push({
            //     productId: x.productId,
            //     productSkuId: x.productSkuId,
            //     supplyPrice: x.supplyPrice,
            //     retailPrice: x.retailPrice,
            //     merchantsPrice: x.merchantsPrice,
            //     marketPrice: x.marketPrice,
            //     isActive: true,
            //     isShelves: x.isShelves
            //   });
            // });
            // console.log('this.currentRow2.length', this.currentRow2);
            let flag = true;
            if (this.currentRow2.length <= 0) {
                flag = false
                this.$message.error('请选择要添加的商品')
            }
            this.currentRow2.forEach((item, index) => {
                if (item.priceType == 1) {
                    item.retailPrice = item.supplyPrice;
                    item.merchantsPrice = item.supplyPrice;
                    item.marketPrice = item.supplyPrice;
                }
            })
            // if (this.currentRow2){

            this.currentRow2.forEach(item => {
                if (!item.supplyPrice) {
                    flag = false
                    this.$message.error('输入供货价')

                }
                if (!item.merchantsPrice) {
                    flag = false
                    this.$message.error('输入商家价')
                }
                if (!item.retailPrice) {
                    flag = false
                    this.$message.error('输入零售价')
                }
                if (!item.marketPrice) {
                    flag = false
                    this.$message.error('输入市场价')
                }
                if (!item.defaultStock) {
                    flag = false
                    this.$message.error('输入默认库存')
                }
                if (item.isShelves === null) {
                    flag = false
                    this.$message.error('请选择上下架')
                }
                // if (Number(item.retailPrice) > Number(item.marketPrice)) {
                //     flag = false
                //     this.$message.error('市场价必须大于等于C端价！')
                // }
                // if (Number(item.merchantsPrice) > Number(item.retailPrice)) {
                //     flag = false
                //     this.$message.error('C端价必须大于等于B端价！')
                // }
                // if (Number(item.supplyPrice) > Number(item.merchantsPrice)) {
                //     flag = false
                //     this.$message.error('B端价必须大于等于供货价！')
                // }
            })
            // }
            if (flag) {
                this.currentRow2.forEach((item, index) => {
                    if (item.priceType == 1) {
                        item.retailPrice = item.supplyPrice;
                        item.merchantsPrice = item.supplyPrice;
                        item.marketPrice = item.supplyPrice;
                    }
                })
                let params = {
                    resellerId: this.distributorId,
                    items: this.currentRow2
                };
                // console.log('params添加商品参数', params);
                this.$confirm("本次操作是否同步相应的分销商？", "提示", {
                    closeOnClickModal: false,
                }).then(() => {
                    this.productCreateOrUpdateAndSync('create', params, true);
                }).catch(() => {
                    this.productCreateOrUpdateAndSync('create', params, false);
                });
            }
        },
        switchShelves(row) {
            let params = {
                supplyPrice: row.supplyPrice,
                retailPrice: row.retailPrice,
                merchantsPrice: row.merchantsPrice,
                marketPrice: row.marketPrice,
                isActive: true,
                isShelves: !row.isShelves,
                id: row.id,
                defaultStock: row.defaultStock
            };
            SaleableSkuUpdate(params).then((res) => {
                this.tableLoading = false;
                if (res.data.success) {
                    this.$message.success('修改成功');
                    this.getTableList();
                } else {
                    this.$message.error(res.error.message);
                }
            })
        },
        copySupplyPrice() {
          this.updateSupPrice(this.tableList)
        },
        async updateSupPrice(arr) {
          // 根据类型处理价格
          // if (data.priceType == 1) {
          //     data.merchantsPrice = data.supplyPrice;
          //     data.retailPrice = data.supplyPrice;
          //     data.marketPrice = data.supplyPrice;
          // }
          // let row = data;
          // if (
          //     Number(row.marketPrice) < Number(row.retailPrice)
          // ) {
          //     return this.$message.error('市场价必须大于等于C端价！');
          // }
          // if (
          //     Number(row.retailPrice) < Number(row.merchantsPrice)
          // ) {
          //     return this.$message.error('C端价必须大于等于B端价');
          // }
          // if (
          //     Number(row.merchantsPrice) < Number(row.supplyPrice)
          // ) {
          //     return this.$message.error('B端价必须大于等于供货价');
          // }
          
          let items = [];
          for (var i in arr) {
            let params = {};
            params.supplyPrice = arr[i].supplyPrice;
            params.retailPrice = arr[i].supplyPrice;
            params.merchantsPrice = arr[i].supplyPrice;
            params.marketPrice = arr[i].supplyPrice;
            params.id = arr[i].id;
            items.push(params)
          }
          BatchUpdatePrice({items}).then((res) => {
            if (res.data.success) {
              // this.$message.success('修改价格成功');
              // if (res.data.result.success) {
              //   this.$message.success(res.data.result.message)
              this.getTableList();
              // } else {
              //   this.$message.error(res.data.result.message)
              // }

            } else {
              this.$message.error(res.error.msg || '操作失败,请重试');
            }
          });
        },
        productSync_fun(params) {
            let row = params.funcParams;
            if (!row.supplyPrice || row.supplyPrice == '') {
                this.resetScrollX();
                return this.$message.error('请输入供货价格！');
            }
            if (row.retailPrice === null || row.retailPrice === '') {
                this.resetScrollX();
                return this.$message.error('请输入零售价格！');
            }
            if (row.merchantsPrice === null || row.merchantsPrice === '') {
                this.resetScrollX();
                return this.$message.error('请输入商家价格！');
            }
            if (row.marketPrice === null || row.marketPrice === '') {
                this.resetScrollX();
                return this.$message.error('请输入市场价格！');
            }
            let data = {
                resellerId: this.distributorId,
                saleableSkuIds: [row.productSkuId]
            };
            this.proSync(data);
        },
        detail(params) {
            // let row = params.funcParams;
            // this.$router.push(`/Product/ComManagement/EditProduct?id=${row.productId}`)
            this.$router.push(`/Product/AddEditSpu?id=${params.productId}`)
        },
        renderButton() {
            let routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : [];
            var buttonList = getButtonList(this.$route.path, routers);
            this.isCopySupplyPrice = buttonList.find(i=>i.buttonFunc==='copySupplyPrice')
            this.buttonList_toolBar = buttonList.filter((item) => {
                return item.buttonShow == 10 && item.isVisible;
            });
            this.buttonList_table = this.$utils.sortDataArrayAsc(buttonList.filter((item) => {
                return item.buttonShow == 20 && item.isVisible;
            }), 'order');
            this.buttonList_table && this.buttonList_table.forEach((item, index) => {
                if (item.buttonFunc === 'productSync_fun') {
                    this.isProductSync = true
                }
            })
            this.buttonList_table && this.buttonList_table.forEach((item, index) => {
                if (item.buttonFunc === 'detail') {
                    this.isDetail = true
                }
            })
            this.buttonList_table && this.buttonList_table.forEach((item, index) => {
                if (item.buttonFunc === 'editPrice') {
                    this.isEditPrice = true
                }
            })
            this.buttonList_table && this.buttonList_table.forEach((item, index) => {
                if (item.buttonFunc === 'asyncPrice') {
                    this.isAsyncPrice = true
                }
            })
        },
        mergeColumn({row, column, rowIndex, columnIndex}) {
            if (columnIndex === 0 || columnIndex === 1) {
                if (rowIndex % 2 === 0) {
                    return {
                        rowspan: 2,
                        colspan: 1
                    };
                } else {
                    return {
                        rowspan: 0,
                        colspan: 0
                    };
                }
            }
        },
        callFunction(item) {
            this[item.buttonFunc](item);
        },
        handleSync(count, price) {
            if (this[count] !== undefined) {
                this.productList.forEach(item => {
                    item[price] = (item.costPrice / (1 - this[count])).toFixed(2)
                })
            }
        },
        syncStock() {
            if (this.count5 !== undefined) {
                this.productList.forEach(item => {
                    item.defaultStock = this.count5
                })
            }
        },
        upordown(type) {
            this.productList.forEach(item => {
                item.isShelves = type
            })
        }
    }
};
</script>
<style scoped>
#main-box {
    width: 100%;
    height: 100%;
}

#content-box {
    padding: 0 20px 20px 20px;
    width: 100%;
    height: 100%;
}

#main-box /deep/ .el-pagination {
    /* padding: 10px 5px; */
}

.table-header-btn {
    margin-left: 5px;
}
</style>
